import { Link } from "react-router-dom";

type Props = {
  toLink: string;
  title?: string;
  toIcon: string;
  onClickDelete?: () => void; //Eliminamos la orden de compra
};

export const HeaderPlpMovil = ({
  toLink,
  title,
  toIcon,
  onClickDelete
}: Props): JSX.Element => {
  return (
    <>
      <div className="w-25">
        <Link className="header__back" to={toLink} onClick={onClickDelete}>
          <i className="icon-chevron-left text-white"></i>
        </Link>
      </div>
      <div className="w-100 d-flex justify-content-center align-items-center mx-auto">
        <h4 className="mt-3 text-white">{title}</h4>
      </div>
      <div className="w-25 d-flex justify-content-center align-items-center mx-auto">
        <Link className="header__back" to={toIcon} onClick={onClickDelete}>
          <i className="icon-home3 text-white"></i>
        </Link>
      </div>
    </>
  );
};
